/*
 * File: ApptCardList.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: List of Appointment Cards
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import ApptCard from "./ApptCard";
import CreateTimeSlots from "services/appointments/components/CreateTimeSlots";
import UINotFound from "components/ui/UINotFound";
import PropTypes from "prop-types";
import { PropTypes as MobxPropTypes } from "mobx-react";
import { Link } from "react-router-dom";
import { usePreference } from "utils/useStore";

const styles = theme => ({
  root: {
    width: "100%"
  },
  subHeader: {
    fontSize: theme.spacing(2.5),
    textAlign: "left",
    backgroundColor: theme.palette.common.headerbg
  },
  ul: {
    backgroundColor: theme.palette.common.white,
    padding: 0
  }
});

/**
 * Sets the patient id from the appointment record in the patient store
 * and redirects to the appointment page
 **/
const ApptCardList = ({ appts, classes }) => {
  const filters = usePreference("apptFilters");

  const apptCards = appts => {
    return appts.map((appt, idx) => {
      const apptLink = "/appointments/" + appt.appointmentId;
      return (
        <Link to={apptLink} key={idx}>
          <ListItem>{<ApptCard appt={appt} />}</ListItem>
        </Link>
      );
    });
  };

  const apptList = () => {
    const order = Number(filters.order) === 1 ? "asc" : "";
    const timeSlots = CreateTimeSlots(appts, "startTime", order);

    return Object.keys(timeSlots).map((time, idx) => {
      return (
        <li key={idx}>
          <ul className={classes.ul}>
            <ListSubheader className={classes.subHeader}>{time}</ListSubheader>
            {apptCards(timeSlots[time])}
          </ul>
        </li>
      );
    });
  };

  if (!appts || appts.length === 0) {
    return (
      <UINotFound message="There Are No Appointments Scheduled On This Day" />
    );
  }

  return (
    <List id="#appts" className={classes.root} subheader={<li />}>
      {apptList()}
    </List>
  );
};

ApptCardList.propTypes = {
  appts: MobxPropTypes.observableArray.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ApptCardList);
